/* Bob Laadt Op — bob-reasons: het eerlijke tegengeluid (<details class="honest">).
   Het openen/sluiten doet de browser zelf. Dit element zorgt er alleen voor dat
   de uitklap in de theme editor opengaat als je een honest_item-block selecteert,
   zodat je ziet wat je bewerkt. */

if (!customElements.get('bob-reasons')) {
  class BobReasons extends HTMLElement {
    connectedCallback() {
      this.details = this.querySelector('details.honest');
      if (!this.details) return;

      this.onBlockSelect = (event) => {
        if (this.contains(event.target)) this.details.open = true;
      };
      document.addEventListener('shopify:block:select', this.onBlockSelect);
    }

    disconnectedCallback() {
      if (this.onBlockSelect) document.removeEventListener('shopify:block:select', this.onBlockSelect);
    }
  }

  customElements.define('bob-reasons', BobReasons);
}
